<div class="mock-browser">
  <!-- Browser Header -->
  <div class="mock-browser-header">
    <div class="mock-url-bar">
      <span class="mock-url-icon">🌐</span>
      <div class="mock-url-text"></div>
    </div>
    <div class="mock-controls">
      <span class="mock-control">—</span>
      <span class="mock-control">□</span>
      <span class="mock-control close">✕</span>
    </div>
  </div>

  <!-- Browser Content -->
  <div class="mock-browser-content">

    <!-- Top Strip -->
    <div *ngIf="notification?.BroadcastNotificationTypeId === BroadcastNotificationTypes.TopStrip"
         class="mock-top-strip"
         [style.background-color]="notification?.BackgroundColor || '#2196f3'"
         [style.color]="notification?.TextColor || 'white'">
      <div class="mock-top-strip-content">
        <mat-icon class="mock-icon">campaign</mat-icon>
        <span class="mock-title" data-testid="banner-title">{{ notification?.Title }}</span>
        <span class="mock-link" [style.color]="notification?.TextColor">View details</span>
        <mat-icon *ngIf="notification?.IsDismissible" class="mock-close" data-testid="banner-close-button">close</mat-icon>
      </div>
    </div>

    <!-- App Header -->
    <div class="mock-app-header">
      <div class="mock-logo-placeholder"></div>
      <div class="mock-nav-placeholder">
        <div class="mock-nav-item"></div>
        <div class="mock-nav-item"></div>
        <div class="mock-nav-item"></div>
      </div>
    </div>

    <!-- Banner -->
    <div *ngIf="notification?.BroadcastNotificationTypeId === BroadcastNotificationTypes.Banner"
         class="mock-banner"
         [style.background-color]="notification?.BackgroundColor || '#2196f3'"
         [style.color]="notification?.TextColor || 'white'">
      <div class="mock-banner-content">
        <mat-icon class="mock-icon">campaign</mat-icon>
        <span class="mock-title" data-testid="banner-title">{{ notification?.Title }}</span>
        <span class="mock-link" [style.color]="notification?.TextColor">View details</span>
        <mat-icon *ngIf="notification?.IsDismissible" class="mock-close" data-testid="banner-close-button">close</mat-icon>
      </div>
    </div>

    <!-- Notification -->
    <div *ngIf="notification?.BroadcastNotificationTypeId === BroadcastNotificationTypes.Notification"
         class="mock-notification-float"
         [style.background-color]="notification?.BackgroundColor || '#2196f3'"
         [style.color]="notification?.TextColor || 'white'">
      <div class="mock-toast-content">
        <mat-icon class="mock-icon">campaign</mat-icon>
        <span class="mock-title" data-testid="banner-title">{{ notification?.Title }}</span>
        <span class="mock-link" [style.color]="notification?.TextColor">View details</span>
        <mat-icon *ngIf="notification?.IsDismissible" class="mock-close" data-testid="banner-close-button">close</mat-icon>
      </div>
    </div>

    <!-- Main Content Area -->
    <div class="mock-main-content">
      <div class="mock-content-header">
        <div class="mock-page-title"></div>
      </div>
      <div class="mock-content-grid">
        <div class="mock-content-card">
          <div class="mock-card-header"></div>
          <div class="mock-card-lines">
            <div class="mock-line"></div>
            <div class="mock-line short"></div>
          </div>
        </div>
        <div class="mock-content-card">
          <div class="mock-card-header"></div>
          <div class="mock-card-lines">
            <div class="mock-line"></div>
            <div class="mock-line short"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
